export function normalizeBaseUrl(baseUrl: string) {
  if (baseUrl.trim().endsWith('/')) {
    return baseUrl.trim().substring(0, baseUrl.trim().length - 1);
  } else {
    return baseUrl.trim();
  }
}
